import { AssistentItem } from '../assistent_config';
import { DataService } from '../../../../services/data_service';
import { getWetterstation } from '../../functions/getWetterstation';
import { IDs } from '../../../../helpers/IDs';
import * as React from 'react';
import { TriggerService } from '../../../../core/trigger/trigger_service';
import { WActionButton } from '../../../../core/elements/WActionButton';
import { WFormData } from '../../../../core/forms/WFormData';
import { Features } from '../../../../control/features';
import { hasFeature } from '../../../../control/hasFeature';

let lastAdressString: string;

export function getAssistentConfigStandorte(dataGlobal: any, dataService: DataService, triggerService: TriggerService, customCfg?: AssistentItem): AssistentItem {
    const config: any = require('../../../../wips.config.js');
    const konfiguration: Array<any> = dataGlobal[IDs.ENT_KONFIGURATION] || [];
    const disableStandorte: boolean = !konfiguration.some((param: any) => param.mehrere_standorte_orig === 1);

    // const enableStandorteGruppen: boolean = config.devFeaturesMap && config.devFeaturesMap.N118_STANDORT_GRUPPIERUNG ? true : false;
    const bereichKey = dataGlobal[IDs.ENT_UNTERNEHMENSDATEN][0].bereich_key_orig;
    const enableStandorteGruppen = hasFeature(Features.STANDORT_GRUPPEN, bereichKey);

    const eingabe_standorte: AssistentItem = {
        gliederung: '1.3',
        name: 'Standorte',
        description: 'Dies ist das Formular zur Eingabe der Standort-Daten.',
        type: 'EntityForm',
        entity: IDs.ENT_STANDORT,
        module: IDs.MOD_ETOOL,
        style: { marginLeft: '18px' },
        singleItem: disableStandorte,
        configFlag: 'checkStandorte',
        addLabel: 'Neuer Standort',
        vorhandenName: 'Standorte',
        customFilter: (item: any) => item.standort_typ_tid_orig !== 6 && item.standort_typ_tid_orig !== 5,
        onFormChangeInteractive: async (formData: WFormData, onValueChange: (name: string, value: any) => void) => {
            lastAdressString = await getWetterstation(dataGlobal, lastAdressString, formData, onValueChange);
        },
        bundleFilterFunc: (bundle: any, dat: any) => {
            bundle.standort_typ_tid = bundle.standort_typ_tid.filter((item: any) => item.tid !== 5 && item.tid !== 6);
        },
        // Bitte so weit wie möglich in getCustomFormConfig.ts anpassen.
        customFormConfig: {
            gruppe: enableStandorteGruppen ? {} : { hidden: true }
        },
        formGroupOrder: [
            {
                foldable: false,
                folded: false,
                fields: ['name', 'gruppe', 'tochtergesellschaften', 'standort_typ_tid', 'standort_tid', 'energiedaten_erfassen', 'plz', 'ort']
            },
            {
                title: 'Optionale Daten',
                titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                foldable: true,
                folded: true,
                fields: ['strasse', 'hausnummer', 'datum_von', 'datum_bis', 'ort_gtz', 'foto']
            }
        ],
        disableFieldSelectDefaultOptions: {
            standort_typ_tid: true,
            energiedaten_erfassen: true
        },
        callBeforeDelete: (row: any, callback: () => void) => {
            const veranstaltungFnd = dataGlobal[IDs.ENT_STANDORT].find((v: any) => v.tid !== row.tid
                && v.standort_typ_tid_orig === 5 /* Veranstaltung - eigener Standort */ && v.standort_tid_orig === row.tid);
            // console.log(row, veranstaltungFnd);
            if (veranstaltungFnd) {
                alert(`Dieser Standort darf nicht gelöscht werden, da dem Standort die Veranstaltung "${veranstaltungFnd.name}" zugeordnet ist.`);
            } else {
                callback();
            }
        },
        ...(customCfg || {})
    };

    return eingabe_standorte;
}

function getHauptsitzButton(entity: string, item: any, data: any,
    dataService: DataService, triggerService: TriggerService, callback?: (data: any) => void) {
    // console.log('getHauptsitzButton', entity, item);
    if (!item || (item.standort_typ_tid !== 'Hauptsitz' && item.standort_typ_tid !== 1)) {
        return <div></div>;
    }
    return <WActionButton
        label='Unternehmensdaten für Hauptsitz übernehmen'
        insideText='Unternehmensdaten für Hauptsitz übernehmen'
        tooltip='Unternehmensdaten für Hauptsitz übernehmen'
        key='copy'
        action='copy'
        onAction={() => {
            if (Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) && data[IDs.ENT_UNTERNEHMENSDATEN].length > 0 &&
                Array.isArray(data[IDs.ENT_STANDORT]) && data[IDs.ENT_STANDORT].length > 0) {
                const unt = data[IDs.ENT_UNTERNEHMENSDATEN][0];
                const hauptList = data[IDs.ENT_STANDORT].filter((s: any) => s.standort_typ_tid_orig === 1)
                    .map((s: any) => {
                        return {
                            tid: s.tid,
                            strasse: unt.strasse,
                            hausnummer: unt.hausnummer,
                            ort: unt.ort,
                            plz: unt.plz
                        };
                    });
                // console.log(hauptList);
                if (hauptList.length > 0) {
                    dataService.saveDataList(IDs.ENT_STANDORT, hauptList, () => {
                        triggerService.fire('reload', IDs.ENT_STANDORT, callback);
                    }, IDs.MOD_ETOOL);
                }
            }
        }}
    />;
}
